import { ClientEvents } from "#resources/Events"
import ReconnectingEventSource from "reconnecting-eventsource"

const parseEvent = S.decodeUnknownSync(ClientEvents)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function listener(message: MessageEvent<any>) {
  const evt = parseEvent(JSON.parse(message.data))
  bus.emit("serverEvents", evt)
}

export function useEventSource() {
  const config = useRuntimeConfig()
  const apiUrl = config.public.apiUrl || "http://localhost:4200"
  function makeSource() {
    const src = new ReconnectingEventSource(apiUrl + "/events")
    src.addEventListener("message", listener)
    return src
  }

  onMountedWithCleanup(() => {
    const source = makeSource()

    return () => {
      console.log("$closing source")
      source.removeEventListener("message", listener)
      source.close()
    }
  })
}
